export default __webpack_public_path__ + "static/media/bullets-rtl.635ece21.svg";